import axios from 'axios'

function parseData (rss_xml) {
    let dom = new window.DOMParser().parseFromString(rss_xml, "text/xml")
    const items = dom.querySelectorAll('item')
    let list = []
    for (let item of items) {
        let title = item.querySelector("title").innerHTML
        let description = item.querySelector("description").innerHTML
        let pubDate = item.querySelector("pubDate").innerHTML
        let link = item.querySelector("link").innerHTML
        if (description.startsWith('<![CDATA[')) {
            description = description.substring('<![CDATA['.length, description.length - ']]>'.length)
        }
        let imgStart = description.indexOf('src="')
        let imgEnd = description.indexOf('"', imgStart + 'src="'.length)
        let img = description.substring(imgStart + 'src="'.length, imgEnd)
        description = description.substring(description.indexOf('</br>') + '</br>'.length)
        if (img.startsWith('http')) {
            list.push({ title, description, pubDate, link, img })
        }
    }
    return list
}

function parseDataFptPlay (data) {
    return data.map(item => {
        return {
            title: item.title,
            description: item.description,
            pubDate: '',
            link: item.web_url,
            img: item.poster_vertical
        }
    })
}

const RSSService = {
    getData (source) {
        if (source === 'vne') {
            let list = {
                'Tin mới nhất': 'thoi-su.rss',
                'Thể thao': 'the-thao.rss',
                'Sức khỏe': 'suc-khoe.rss',
                'Ô tô xe máy': 'oto-xe-may.rss',
                'Số hóa': 'so-hoa.rss',
                'Du lịch': 'du-lich.rss',
                'Cười': 'cuoi.rss'
            }
            let promiseList = []
            for (let i in list) {
                promiseList.push(axios.get('https://td.fpt.ai/vne-rss/' + list[i]))
            }
            return Promise.allSettled(promiseList).then(
                results => {
                    let obj = {}
                    let keyList = Object.keys(list)
                    for (let i in keyList) {
                        obj[keyList[i]] = parseData(results[i].value.data)
                    }
                    return obj
                }
            )
        } else {
            let list = {
                'Anime': 'anime-1.json',
                'Điện ảnh': 'dien-anh-1.json',
                'Phim bộ': 'phim-bo-1.json',
                'Phim chiếu rạp': 'phim-chieu-rap-1.json',
                'Phim lẻ': 'phim-le-1.json',
                'Thể thao': 'the-thao-1.json',
                'Thiếu nhi': 'thieu-nhi-1.json'
            }
            let promiseList = []
            for (let i in list) {
                promiseList.push(axios.get(`https://friendsell.fpt.ai/fptplay/rss/${list[i]}`))
            }
            return Promise.allSettled(promiseList).then(
                results => {
                    let obj = {}
                    let keyList = Object.keys(list)
                    for (let i in keyList) {
                        obj[keyList[i]] = parseDataFptPlay(results[i].value.data)
                    }
                    return obj
                }
            )
        }
    }
}

export default RSSService
